/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

/**
 * Configuration context
 */
export const ConfigContext = React.createContext<{
	assetsPath: string;
	mode: "browser"|"ssr";
}>({
	assetsPath: null,
	mode: null
});
